import { useState } from "react"
import ChatBox from "./ChatBox"
import { FiSend, FiUpload } from "react-icons/fi"

import languages from "@/constants/languages"
import FilePicker from "./ui/FilePicker"
import { Input } from "./ui/shadcn/input"
import { Textarea } from "./ui/shadcn/textarea"
import { useShow } from "@/contexts/ShowContext"
import { Checkbox } from "./ui/shadcn/checkbox"

export default function AssetEditor({ defaultValue, onChange, accept = '*/*', allowTags = true, allowMultiTags = true }) {
    const [asset, setAsset] = useState({
        name: 'New Asset',
        description: '',
        tags: [],
        ...(defaultValue || {})
    })

    const {show} = useShow()
    
    const handleChange = (e) => {
        const newAsset = {...asset, [e.target.name]: e.target.value}
        setAsset(newAsset)
        if(onChange) onChange(newAsset)
    }

    const handleFileSelect = (file) => {
        setAsset(prev => ({...prev, file : file}))
        if(onChange) onChange({...asset, file: file})
    }

    const handleTagChange = (tagId, checked) => {
        if(allowMultiTags){
            setAsset(prev => ({...prev, tags: checked ? [...prev.tags, tagId] : prev.tags.filter(t => t !== tagId)}))
            if(onChange) onChange({...asset, tags: checked ? [...asset.tags, tagId] : asset.tags.filter(t => t !== tagId)})
        }
        else{
            setAsset(prev => ({...prev, tags: checked ? [tagId] : []}))
            if(onChange) onChange({...asset, tags: checked ? [tagId] : []})
        }
    }

    return (
        <div className='flex flex-col gap-4 w-full h-full p-4 overflow-y-auto'>
            <div className='flex flex-col gap-2'>
                <label htmlFor="name" className='text-xs text-secondary-foreground'>Name</label>
                <Input name='name' defaultValue={asset.name} onChange={handleChange} autoComplete="off" />
            </div>
            
            <div className='flex flex-col gap-2'>
                <label className="text-xs text-secondary-foreground">Media</label>
                <FilePicker className='w-full aspect-video bg-background' disabled={asset.source==='wsc_import' || asset.source==='show_import'} type={asset?.mediaType} preview={asset?.url} onChange={handleFileSelect} accept={accept} label="Upload Image" icon={<FiUpload className="w-4 h-4" />} />
            </div>
            
            <div className='flex flex-col gap-2'>
                <label htmlFor="description" className='text-xs text-secondary-foreground'>Description</label>
                <Textarea name='description' defaultValue={asset.description} onChange={handleChange} />
            </div>   
            {asset.aiDescription && <div className='flex flex-col gap-2'>
                <label className='text-xs text-secondary-foreground'>AI Description</label>
                <span className='border p-2 rounded-md text-xs text-secondary-foreground/60'>{asset.aiDescription}</span>
            </div>}
            {allowTags && <div className='flex flex-col gap-2'>
                <label className="text-xs text-secondary-foreground">Tags</label>
                {show.asset_categories.map(tag => (
                    <div key={tag._id} className='flex items-center gap-2 cursor-pointer'>
                        <Checkbox id={`editor-tag-${tag._id}`} name={tag._id} checked={asset.tags.includes(tag._id)} onCheckedChange={(checked) => handleTagChange(tag._id, checked)} />
                        <label htmlFor={`editor-tag-${tag._id}`} className='text-xs text-secondary-foreground capitalize select-none'>{tag.name}</label>
                    </div>
                ))}
            </div>}
        </div>
    )
}